import { render } from "./TemasTemporarios.vue?vue&type=template&id=43ac4ba9&scoped=true"
import script from "./TemasTemporarios.vue?vue&type=script&lang=js"
export * from "./TemasTemporarios.vue?vue&type=script&lang=js"

import "./TemasTemporarios.vue?vue&type=style&index=0&id=43ac4ba9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ac4ba9"]])

export default __exports__